module.exports = __webpack_public_path__ + "static/media/pediatrica.64e63c2a.svg";